__webpack_require__.p = "https://stg-scora.calyb.ai/";